// extracted by mini-css-extract-plugin
export default {"root":"vWyjD3","checkbox":"tpafTN","checkboxError":"ImM4Gy"};